import * as _ from 'lodash'
import React, { useState } from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import { useJobCostItemDragDrop } from '../draggableJobCostLineItem';
import valueFilters from '../valueFilters';
import util from '../util';
import jobCostNoteFactory from '../models/jobCostNoteModel';
import enums from '../enum';
import * as contractorActions from '../contractorActions';
import { AsyncButton, Confirm, CurrencyInput, Expander, Header, jobCostRowOwner, JobCostHiddenWhenLocked, JobCostLockable, PercentInput, PinnableStats } from './sharedComponents';

class LookupSection extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { selectedContractor: undefined };

		this.callbackFromNewContractor = this.callbackFromNewContractor.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.updateModel = this.updateModel.bind(this);
	}

	updateState (updater) {
		this.setState(previousState => {
			const nextState = _.assign({}, previousState);

			updater(nextState);

			return nextState;
		});
	}

	handleClick (e) {
		e.preventDefault();

		if (this.state.selectedContractor === undefined) {
			return;
		}
		else {
			this.props.buttonHandler(this.state.selectedContractor);

			this.updateState(nextState => {
				nextState.selectedContractor = undefined;
			});
		}
	}

	cancelClicked () {
		actions.popModal();
	}

	updateModel (e) {
		const value = e.target.value;
		this.updateContractor(value);
	}

	updateContractor (key) {
		this.updateState(nextState => {
			nextState.selectedContractor = this.findContractor(key);
		});
	}

	findContractor (key) {
		return _.find(this.props.contractorList, { key: key });
	}

	callbackFromNewContractor (name) {
		actions.popModal();

		const matchedContractor = this.findContractor(name);

		if (matchedContractor !== undefined) {
			this.props.buttonHandler(matchedContractor);
		}
	}

	render () {
		const { jobCost, contractorList } = this.props;
		const { selectedContractor } = this.state;
		const companyOptions = [<option key="blank" value="">Select a Sub Trade</option>];
		_.forEach(contractorList, (contractor) =>{
			companyOptions.push(<option key={contractor.key} value={contractor.key}>{ `${contractor.name} - ${contractor.primaryContactName}` }</option>);
		});

		return (
			<div className="inner">
				<table className="compact" cellPadding="0" cellSpacing="0">
					<tbody>
						<JobCostLockable jobCost={ jobCost } lockedClass="disabled">{ ({ getClassName }) =>
							(<tr className={ getClassName() }>
								<td />
								<td>
									<select placeholder="Select a Sub Trade" value={ util.reactVal(selectedContractor && selectedContractor.key) } onChange={ this.updateModel } >
										{ companyOptions }
									</select>
								</td>
								<td className="action"><button className="icon iconOnly addItem" onClick={this.handleClick}><span /></button></td>
								<td />
							</tr>)
						}
						</JobCostLockable>
					</tbody>
				</table>
			</div>
		);
	}
}

const SubtradeCostRow = (props) => {
	const { alwaysValidate, buttonHandler, classNames = [], draggable, buttonClass, dropLineItem, lineItem, updateModel, subtradeTypeOptions } = props;
	const [shouldValidate, setShouldValidate] = useState(alwaysValidate);
	const [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef, rowRef}] = useJobCostItemDragDrop({ 
		item: lineItem,
		handleDrop: (dragItem, dropItem) => dropLineItem(dragItem.key, dropItem.key) 
	});

	function validate (property?) {
		if (!property || shouldValidate) {
			const result = !lineItem.test(property);

			return result;
		}
		return true;
	}

	function handleButtonClick (e) {
		e.preventDefault();

		const valid = validate();

		if (!valid) {
			setShouldValidate(true);
		}
		else {
			// this assumes that the add handler succeeds
			setShouldValidate(alwaysValidate);
		}

		buttonHandler(valid, e);
	}

	function handleUpdate (path, autoSave, e) {
		let newVal;
		if (e.target.type === 'checkbox') {
			newVal = e.target.checked;
		}
		else if (path === 'description') {
			newVal = (autoSave) ? valueFilters.trim(e.target.value) : e.target.value;
		}
		else {
			newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;
		}

		updateModel((model, updateCallback) => {
			model.setAt(path, newVal);

			updateCallback(model, path);
		}, { autoSave: autoSave });
	}

	let dropClass = null;
	const dragClass = isDragging ? 'disabled' : null;

	if (dropItem) {
		const dropIndex = lineItem.sortIndex;
		const dragIndex = dropItem.sortIndex;

		dropClass = (dropIndex > dragIndex) ? 'dropBottom' : 'dropTop';
	}

	const rowClasses = _.concat(classNames, dropClass, dragClass);
	const dragHandle = (draggable) ? <button ref={ dragSourceRef } className="icon iconOnly drag"><span /></button> : null;

	//onChange={this.updateModel.bind(this, 'sellPrice', false)} onBlur={this.updateModel.bind(this, 'sellPrice', true)}
	return <tr ref={ rowRef } className={ rowClasses.join(' ') }>
		<td />
		<td>{dragHandle}</td>
		<td className="category"><select value={lineItem.viewValue('subTradeTypeKey')} onChange={e => handleUpdate('subTradeTypeKey', true, e)} >
			{ subtradeTypeOptions }
		</select></td>
		<td><textarea style={rowClasses.indexOf('readOnly') !== -1 ? {pointerEvents: 'stroke'} :{}} className="lineItemDescription" placeholder="Enter" value={lineItem.viewValue('description')} onChange={e => handleUpdate('description', false, e)} onBlur={e => handleUpdate('description', true, e)} readOnly={rowClasses.indexOf('readOnly') !== -1} /></td>
		<td className="centered"><input className="" type="checkbox" checked={lineItem.isOptional} onChange={e => handleUpdate('isOptional', true, e)} /></td>
		<td className="cost"><CurrencyInput className="" type="text" value={lineItem.viewValue('cost')} onChange={e => handleUpdate('cost', false, e)} onBlur={e => handleUpdate('cost', true, e)} /></td>
		<td className="margin"><PercentInput className="" type="text" value={lineItem.viewValue('costFactor')} onChange={e => handleUpdate('costFactor', false, e)} onBlur={e => handleUpdate('costFactor', true, e)} /></td>
		<td className="cost"><CurrencyInput className="" type="text" value={lineItem.viewValue('sellPrice')} onChange={e => handleUpdate('sellPrice', false, e)} onBlur={e => handleUpdate('sellPrice', true, e)} /></td>
		<td><button className={buttonClass} onClick={handleButtonClick}><span /></button></td>
		<td />
	</tr>;
}

const ContractorSection = jobCostRowOwner({ listAccessor: model => model.lineItems, listFilterThunkFactory: props => row => row.type === props.type }, class SubtradeSection extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);

		this.dropLineItem = this.dropLineItem.bind(this);
		this.handleRemoveContractorClick = this.handleRemoveContractorClick.bind(this);
	}

	getStateFromProps (props) {
		const state = _.assign({ printing: false }, this.state);

		if (!state.pendingLineItem || state.pendingLineItem.type !== props.type) {
			state.pendingLineItem = this.createPendingLineItem(props);
		}

		return state;
	}

	addLineItemHandler (lineItemKey, isValid) {
		if (!isValid) {
			return;
		}

		this.props.updateModel(model => {
			if (lineItemKey === this.state.pendingLineItem.key) {
				this.state.pendingLineItem.sortIndex = this.props.getNextSortIndex(model);
				model.lineItems.set(lineItemKey, this.state.pendingLineItem);
				this.props.sortRows(model);

				this.setState({ pendingLineItem: this.createPendingLineItem(this.props) });
			}
		}, { autoSave: true });
	}

	createPendingLineItem (props) {
		const { jobCost, type } = props;

		return jobCost.createLineItem({ type: type, contractorKey: props.contractor.key, subTradeTypeKey: props.contractor.defaultSubTradeTypeKey });
	}

	updateModel (key, updater, options) {
		this.props.updateModel((jobCost, lineItemUpdateCallback) => {
			let lineItem = jobCost.lineItems.get(key);

			if ((!lineItem) && (key === this.state.pendingLineItem.key)) {
				lineItem = this.state.pendingLineItem;
				options.autoSave = false;
			}

			if (lineItem) {
				updater(lineItem, lineItemUpdateCallback);
			}
		}, options);
	}

	updateNote (autoSave, e) {
		const newVal = autoSave ? valueFilters.trim(e.target.value) : e.target.value;
		const contractorKey = this.props.contractor.key;

		this.props.updateModel(jobCost => {
			let note = jobCost.getNote(jobCostNoteFactory.NOTE_TYPES.CONTRACT_SUBTRADE, contractorKey);

			if (!note) {
				note = jobCostNoteFactory({ type: jobCostNoteFactory.NOTE_TYPES.CONTRACT_SUBTRADE, relatedKey: contractorKey });
				jobCost.notes.add(note);
			}

			note.content = newVal;
		}, { autoSave: autoSave });
	}

	handleRemoveContractorClick () {
		const deleter = () => {
			this.props.removeContractor(this.props.contractor);
			actions.popModal();
		};
		const title = `Remove ${this.props.contractor.name}?`;

		actions.pushModal({
			component: <Confirm title={title} message="Are you sure you want to remove this contractor?" confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ deleter } />
		});
	}

	dropLineItem (sourceKey, targetKey) {
		this.props.updateModel(jobCost => {
			const sourceItem = jobCost.lineItems.get(sourceKey);
			const targetItem = jobCost.lineItems.get(targetKey);

			this.props.handleItemDrop(jobCost, sourceItem, targetItem);
		}, { autoSave: true });
	}

	printReport (reportType) {
		const { printReport, contractor, type } = this.props;

		return printReport(reportType, data => {
			data.jobCosts[0].lineItems = _.filter(data.jobCosts[0].lineItems, { type: type, contractorKey: contractor.key });

			return data;
		});
	}

	render () {
		const { contractor, getRowClasses, jobCost, rowContextMenuHandler, subtradeTypes, 
			lineItems, totalIncluded, totalOptional, toggleExpander, isExpanded, costIncluded } = this.props;
		const { pendingLineItem } = this.state;

		const defaultSubtradeType = _.find(subtradeTypes, { key: contractor.defaultSubTradeTypeKey });
		const orderedSubtradeTypes = defaultSubtradeType ? [defaultSubtradeType].concat(_.filter(subtradeTypes, t => t.key !== contractor.defaultSubTradeTypeKey)) : subtradeTypes;

		const subtradeTypeOptions = _.map(orderedSubtradeTypes, (subtradeType)=>{
			return (<option key={subtradeType.key} value={subtradeType.key}>{subtradeType.name}</option>);
		});

		const lineItemsRows = _.map(_.sortBy(lineItems, 'sortIndex'), item => {
			return (
				<SubtradeCostRow
					key={ item.rowKey }
					canDag= { true }
					updateModel={this.updateModel.bind(this, item.key)}
					lineItem={ item }
					subtradeTypeOptions={ subtradeTypeOptions }
					subtradeTypes={ orderedSubtradeTypes }
					buttonHandler={ rowContextMenuHandler.bind(this, item) }
					dropLineItem={ this.dropLineItem }
					classNames={ getRowClasses({ item: item }) }
					buttonClass="icon iconOnly contextMenu"
					canDrag={true}
					alwaysValidate={true}
				/>
			);
		});

		const titlebarActions = [<AsyncButton key="button-print-cost" className="pdf" asyncAction={this.printReport.bind(this, 'subtrade-cost')} label="Print Cost" />, <AsyncButton key="button-print-sell" className="pdf" asyncAction={this.printReport.bind(this, 'subtrade-sell')} label="Print Sell" />];

		return (
			<Expander title={ contractor.name } actions={titlebarActions} toggleExpander={toggleExpander} isExpanded={isExpanded}>
				<div className="inner">
					<table className="compact draggable" cellPadding="0" cellSpacing="0">
						<thead>
							<tr>
								<td />
								<td />
								<td><span className="readOnly">Category</span></td>
								<td><span className="readOnly">Description</span></td>
								<td className="centered"><span className="readOnly">Optional</span></td>
								<td className="cost"><span className="readOnly">Cost</span></td>
								<td className="margin"><span className="readOnly">Markup %</span></td>
								<td className="sell"><span className="readOnly">Sell</span></td>
								<td className="action" />
								<td />
							</tr>
						</thead>
						<tbody>
							<JobCostHiddenWhenLocked jobCost={ jobCost }>
								<SubtradeCostRow
									key={ pendingLineItem.key }
									canDrag={false}
									updateModel={this.updateModel.bind(this, pendingLineItem.key)}
									lineItem={ pendingLineItem }
									subtradeTypeOptions={ subtradeTypeOptions }
									subtradeTypes={ orderedSubtradeTypes }
									buttonHandler={this.addLineItemHandler.bind(this, pendingLineItem.key) }
									classNames={ ['addRow'] }
									buttonClass="icon iconOnly addItem"
								/>
							</JobCostHiddenWhenLocked>
							{lineItemsRows}
						</tbody>
						<tfoot className="subtotal">
							<tr>
								<td />
								<td />
								<td className="right" colSpan={4}>Included Items Cost Subtotal</td>
								<td className="cost" colSpan={2}>{util.formatAsCurrency(costIncluded)}</td>
								<td />
								<td />
							</tr>
							<tr>
								<td />
								<td />
								<td className="right" colSpan={4}>Included Items Subtotal</td>
								<td className="cost" colSpan={2}>{util.formatAsCurrency(totalIncluded)}</td>
								<td />
								<td />
							</tr>
							{ jobCost.currentChangeOrder ? null : <tr>
								<td />
								<td />
								<td className="right" colSpan={4}>Optional Items Subtotal</td>
								<td className="cost" colSpan={2}>{util.formatAsCurrency(totalOptional)}</td>
								<td />
								<td />
							</tr> }
						</tfoot>
					</table>

					<table className="compact" cellPadding="0" cellSpacing="0" >
						<tbody>
							<tr>
								<td />
								<td><textarea value={ jobCost.getNoteContent(jobCostNoteFactory.NOTE_TYPES.CONTRACT_SUBTRADE, contractor.key) } onChange={this.updateNote.bind(this, false)} onBlur={this.updateNote.bind(this, true)} placeholder="Notes" /></td>
								<td />
							</tr>
							<JobCostHiddenWhenLocked jobCost={ jobCost }>
								<tr>
									<td />
									<td className="right"><button className="labelOnly deleteItem" onClick={ this.handleRemoveContractorClick }>Remove { contractor.name }</button></td>
									<td />
								</tr>
							</JobCostHiddenWhenLocked>
						</tbody>
					</table>

				</div>
			</Expander>
		);
	}
});

export default class JobCostEditSubtrades extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = {
			selectedContractors: [],
			contractorList: [],
			subTradeExpanderState: {}
		};

		this.addSubtradeContractor = this.addSubtradeContractor.bind(this);
		this.removeContractor = this.removeContractor.bind(this);
		this.printReport = this.printReport.bind(this);
		this.pinStats = this.pinStats.bind(this);
		this.collapseAll = this.collapseAll.bind(this);
	}

	updateState (updater) {
		this.setState(previousState => {
			const nextState = _.assign({}, previousState);

			updater(nextState);
			return nextState;
		});
	}

	componentDidMount () {
		const { jobCost } = this.props;

		contractorActions.searchContractors({
			filters: { type: enums.contractorTypes.Subtrade_Contractor }
		})
			.then(contractors => {
				this.updateState(nextState => {
					nextState.contractorList = _.sortBy(contractors, 'name');

					_.forEach(_.filter(jobCost.lineItems, { type: 'subtrade' }), lineItem => {
						const contractor = contractors.find(c => { return c.key === lineItem.contractorKey; });
						if (contractor && !_.find(nextState.selectedContractors, { key: contractor.key })) {
							nextState.selectedContractors.push(contractor);
						}
					});

					_.forEach(_.filter(jobCost.notes, { type: jobCostNoteFactory.NOTE_TYPES.CONTRACT_SUBTRADE }), note => {
						const contractor = contractors.find(c => { return c.key === note.relatedKey; });
						if (contractor && !_.find(nextState.selectedContractors, { key: contractor.key })) {
							nextState.selectedContractors.push(contractor);
						}
					});
				});
			});
	}

	addSubtradeContractor (selectedContractor) {
		if (selectedContractor !== undefined) {
			const isContractorAdded = this.state.selectedContractors.find((contractor)=>{ return contractor.key === selectedContractor.key;});
			if (isContractorAdded === undefined) {
				this.updateState(nextState => {
					nextState.selectedContractors = this.state.selectedContractors.concat([selectedContractor]);
				});
			}
		}
	}

	removeContractor (contractorToRemove) {
		this.props.updateModel(jobCost => {
			const lineItemsToDelete = _.filter(jobCost.lineItems, { contractorKey: contractorToRemove.key });
			const notesToDelete = _.filter(jobCost.notes, { relatedKey: contractorToRemove.key });

			_.forEach(lineItemsToDelete, lineItem => {
				jobCost.lineItems.delete(lineItem.key);
			});

			_.forEach(notesToDelete, note => {
				jobCost.notes.delete(note.key);
			});
		}, { autoSave: true });

		//Delete contractor
		this.updateState(nextState => {
			nextState.selectedContractors = this.state.selectedContractors.filter(contractor => {
				if (contractor !== contractorToRemove) {
					return contractor;
				}
			});
		});
	}

	printReport (type, shaper) {
		const { fetchReport } = this.props;

		return fetchReport(`internal/${type}`, shaper);
	}

	pinStats () {
		actions.setPinnedStatState({ key: 'jcSubtrades', isPinned: true });
	}

	collapseAll () {
		const { selectedContractors } = this.state;

		this.setState(previousState => {
			const result = _.assign({}, previousState);
			selectedContractors.map((contractor) => {
				result.subTradeExpanderState['contractor-section-' + contractor.key] = false;
			});

			return result;
		});
	}

	toggleExpander (key) {
		const expanded = this.state.subTradeExpanderState[key];

		this.setState(previousState => {
			const result = _.assign({}, previousState);

			result.subTradeExpanderState[key] = typeof (expanded) === 'undefined' ? false : !expanded;

			return result;
		});
	}

	render () {
		const { jobCost, summary, updateModel } = this.props;
		const { selectedContractors, subTradeExpanderState } = this.state;
		const type = 'subtrade';
		const hasPinnedStats = !!componentServices.store.getIn(['viewState', 'pinnedStats', 'jcSubtrades']);
		const titlebarActions = [<button onClick={ this.collapseAll }><span>Collapse All</span></button>, <AsyncButton className="pdf" asyncAction={ this.printReport.bind(this, 'subtrade-jobcost') } label="Print" />];

		const subtradeTypes = componentServices.store.getIn(['model', 'domainEntities']).subTradeTypes;
		const subtradeItems = jobCost.getLineItemsByType(type);
		const calcItems = summary.getItemsByGroupAndType(type, [type]);

		const rows = selectedContractors.map((contractor) => {
			const lineItems = _.filter(subtradeItems, item => item.contractorKey === contractor.key);
			let contractorTotal = 0;
			let contractorOptionalTotal = 0;
			const isExpanded = typeof (subTradeExpanderState['contractor-section-' + contractor.key ]) === 'undefined' ? true : subTradeExpanderState['contractor-section-' + contractor.key ];
			let costTotal = 0;

			_.forEach(_.filter(calcItems, item => item.contractorKey === contractor.key), item => {
				if (item.isOptional) {
					contractorOptionalTotal += item.sellPrice;
				}
				else {
					contractorTotal += item.sellPrice;
					costTotal += item.cost;
				}
			});

			return (<ContractorSection
				key={'contractor-section-' + contractor.key }
				contractor={ contractor }
				subtradeTypes={subtradeTypes}
				type={ type }
				lineItems={ lineItems }
				jobCost={ jobCost }
				updateModel={updateModel}
				removeContractor={ this.removeContractor }
				printReport={ this.printReport }
				totalIncluded= { contractorTotal }
				costIncluded= { costTotal }
				totalOptional= { contractorOptionalTotal }
				toggleExpander={this.toggleExpander.bind(this, 'contractor-section-' + contractor.key)} 
				isExpanded={isExpanded}
			/>);
		});

		//Total Subtrade
		let totalIncluded = 0;
		let totalOptional = 0;
		let totalCostIncluded = 0;

		_.forEach(calcItems, item => {
			if (item.isOptional) {
				totalOptional += item.sellPrice;
			}
			else {
				totalIncluded += item.sellPrice;
				totalCostIncluded += item.cost;
			}
		});

		return (
			<section>
				<Header title="Sub Trades" actions={ titlebarActions } />
				<section className="jobCostSubTrades">
					<section className="expander expanded">
						<LookupSection buttonHandler={this.addSubtradeContractor} contractorList={ this.state.contractorList } jobCost={this.props.jobCost} />
						{rows}
					</section>
					{ hasPinnedStats ? <section className="stats total pinnable out" /> : null }
					<PinnableStats isPinned={ hasPinnedStats }>
						<section className={ hasPinnedStats ? 'stats total compact' : 'stats total pinnable'}>
							{ hasPinnedStats ? null : <button className="icon iconOnly pinItem" onClick={ this.pinStats }><span /></button> }
							<div className="cost column">
								{util.formatAsCurrency(totalCostIncluded)} <span>COST SUBTOTAL</span>
							</div>
							<div className="cost column">
								{util.formatAsCurrency(totalIncluded)} <span>INCLUDED ITEMS SUBTOTAL</span>
							</div>
							{ jobCost.currentChangeOrder ? null : <div className="cost column">
								{util.formatAsCurrency(totalOptional)} <span>OPTIONAL ITEMS SUBTOTAL</span>
							</div> }
						</section>
					</PinnableStats>
				</section>
			</section>
		);
	}
}